import React from 'react';
import Modal from '../../components/Modal';
import styles from './index.module.scss';
import Button from '../../components/Button';

type Props = {
  onFinish: () => void;
  onCancel: () => void;
};

const FinishDayModal = (props: Props) => {
  return (
    <>
      <Modal onClose={props.onCancel}>
        <h1 className={styles.text}>Are you sure you want to do this</h1>
        <div className={styles.button_group}>
          <Button onClick={props.onFinish} type={'success'}>
            Yes
          </Button>
          <Button onClick={props.onCancel} type={'simple'}>
            No
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default FinishDayModal;
